(function () {
  if (window.customElements && customElements.get('troubleshooting-tips')) return;

  class TroubleshootingTips extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-ts-select]');
      this.panels = Array.from(this.querySelectorAll('[data-ts-panel]'));

      if (this.select) {
        this.select.addEventListener('change', () => this.show(this.select.value));
      }

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-ts-q]');
        if (btn && this.contains(btn)) this.toggleItem(btn);
      });

      this._onResize = this.debounce(() => this.refreshOpen(), 120);
      window.addEventListener('resize', this._onResize);

      if (this.select) {
        this.show(this.select.value);
      } else if (this.panels[0]) {
        this.panels[0].hidden = false;
        this.activate(this.panels[0]);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
    }

    show(handle) {
      this.panels.forEach((panel) => {
        const on = panel.getAttribute('data-ts-panel') === handle;
        panel.hidden = !on;
        if (on) this.activate(panel);
      });
    }

    activate(panel) {
      const items = panel.querySelectorAll('[data-ts-item]');
      items.forEach((item, i) => this.setOpen(item, i === 0));
    }

    toggleItem(btn) {
      const item = btn.closest('[data-ts-item]');
      const panel = btn.closest('[data-ts-panel]');
      if (!item || !panel) return;
      const isOpen = item.classList.contains('is-open');
      panel.querySelectorAll('[data-ts-item]').forEach((it) => this.setOpen(it, false));
      this.setOpen(item, !isOpen);
    }

    setOpen(item, open) {
      item.classList.toggle('is-open', open);
      const btn = item.querySelector('[data-ts-q]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      const answer = item.querySelector('[data-ts-a]');
      if (answer) answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '0px';
    }

    refreshOpen() {
      this.panels.forEach((panel) => {
        if (panel.hidden) return;
        const item = panel.querySelector('[data-ts-item].is-open');
        if (!item) return;
        const answer = item.querySelector('[data-ts-a]');
        if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
      });
    }

    debounce(fn, ms) {
      let t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }
  }

  customElements.define('troubleshooting-tips', TroubleshootingTips);
})();